const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export const MAINTENANCE_TOKEN_KEY = 'tmgMaintenanceToken';

export const getMaintenanceToken = () => {
  try {
    return localStorage.getItem(MAINTENANCE_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setMaintenanceToken = (token) => {
  try {
    if (token) localStorage.setItem(MAINTENANCE_TOKEN_KEY, token);
    else localStorage.removeItem(MAINTENANCE_TOKEN_KEY);
  } catch {
    /* storage blocked - session only */
  }
};

const request = async (path, { method = 'GET', body, auth = true } = {}) => {
  const headers = { 'Content-Type': 'application/json' };
  const token = auth ? getMaintenanceToken() : null;
  if (token) headers['x-maintenance-token'] = token;

  const response = await fetch(`${API_BASE_URL}/maintenance${path}`, {
    method,
    headers,
    ...(body ? { body: JSON.stringify(body) } : {})
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    if (response.status === 401) setMaintenanceToken(null);
    throw new Error(data.message || 'Request failed');
  }

  return data.data;
};

/** Public: is this site (or another registered one) down? */
export const fetchStatus = (siteKey) =>
  request(`/status${siteKey ? `?site=${encodeURIComponent(siteKey)}` : ''}`, { auth: false });

export const login = async (password) => {
  const data = await request('/login', { method: 'POST', body: { password }, auth: false });
  setMaintenanceToken(data.token);
  return data.token;
};

export const listSites = () => request('/sites');

export const addSite = (site_key, name) =>
  request('/sites', { method: 'POST', body: { site_key, name } });

export const updateSite = (siteKey, patch) =>
  request(`/sites/${encodeURIComponent(siteKey)}`, { method: 'PUT', body: patch });

export const removeSite = (siteKey) =>
  request(`/sites/${encodeURIComponent(siteKey)}`, { method: 'DELETE' });
